import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalCellular0BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_cellular_0_bar"}/>
}
